import type { CommunityHost } from '@/mocks/adminCommunity';

interface HostCardProps {
  host: CommunityHost;
}

export default function HostCard({ host }: HostCardProps) {
  return (
    <div className="flex-shrink-0 w-[280px] rounded-2xl border border-rose-200 bg-rose-50 p-4 flex flex-col gap-3 hover:scale-[1.02] transition-transform duration-200 cursor-default">
      {/* Header */}
      <div className="flex items-start gap-3">
        <div className="relative shrink-0">
          <div className="w-14 h-14 rounded-full bg-rose-100 flex items-center justify-center overflow-hidden border-2 border-rose-200">
            <i className="ri-mic-line text-rose-500 text-xl"></i>
          </div>
          {host.isLive && (
            <span className="absolute -bottom-1 -right-1 inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-red-500 text-background-50 text-[9px] font-bold animate-pulse">
              <span className="w-1.5 h-1.5 rounded-full bg-background-50"></span>
              LIVE
            </span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-foreground-950 font-bold text-sm">{host.name}</p>
          <p className="text-foreground-400 text-[11px]">{host.username}</p>
          {host.isActive && (
            <span className="inline-flex items-center gap-1 mt-1 text-emerald-600 text-[10px] font-semibold">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
              Activo
            </span>
          )}
        </div>
      </div>

      {/* Program info */}
      <div className="bg-rose-100/70 rounded-xl p-3 space-y-1.5">
        <div className="flex items-center gap-1.5">
          <i className="ri-radio-line text-rose-600 text-sm"></i>
          <p className="text-foreground-900 font-semibold text-xs">{host.programName}</p>
        </div>
        <div className="flex items-center gap-1.5">
          <i className="ri-time-line text-foreground-400 text-xs"></i>
          <p className="text-foreground-500 text-[11px]">{host.programSchedule}</p>
        </div>
      </div>

      {/* Bio */}
      <p className="text-foreground-500 text-[11px] leading-relaxed line-clamp-2">{host.bio}</p>

      {/* Stats */}
      <div className="flex items-center gap-4 pt-1 border-t border-rose-200/60">
        <div className="flex items-center gap-1">
          <i className="ri-user-heart-line text-foreground-400 text-xs"></i>
          <span className="text-foreground-700 text-xs font-semibold">{host.followers.toLocaleString()}</span>
          <span className="text-foreground-400 text-[10px]">seguidores</span>
        </div>
        <div className="flex items-center gap-1">
          <i className="ri-stack-line text-foreground-400 text-xs"></i>
          <span className="text-foreground-700 text-xs font-semibold">{host.totalPrograms}</span>
          <span className="text-foreground-400 text-[10px]">programas</span>
        </div>
      </div>
    </div>
  );
}